/* Svensk katalog for locale-advisor-reports-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('sv', {
  'adv.cf.cashBasisMissing': 'Kassaunderlaget är inte tillgängligt. Saldo och rörelser måste kunna stämmas av mot huvudboken.',
  'adv.cf.cashBalanceEvidence': 'Bokfört kassa- och banksaldo är {amount}. Detta är inte ett bankbekräftat saldo.',
  'adv.rpt.period.profit': 'Under kvartal {quarter} {year} är intäkterna {income} och överskottet {result}.',
  'adv.rpt.period.loss': 'Under kvartal {quarter} {year} är intäkterna {income} och underskottet {result}.',
  'adv.rpt.period.nativeSuppliers': 'Leverantörslistan avser daterade inköp i kvartalet, exklusive anläggningstillgångar och importerade årssammanställningar utan kvartalsfördelning.',
  'adv.rpt.period.choose': 'Period',
  'adv.rpt.period.year': 'Hela året',
  'adv.rpt.period.yearLabel': 'Hela {year}',
  'adv.rpt.period.quarter': 'Kvartal {quarter}',
  'adv.rpt.period.label': 'Kvartal {quarter} {year}',
  'adv.rpt.period.vsQuarter': 'jämfört med samma kvartal föregående år',
  'adv.rpt.period.quarterBasis': 'Redovisningssiffror för {from}–{to}. Balansräkningen visar saldo vid periodens slut.',
  'adv.rpt.period.currentStatus': 'Uppföljningsstatus vid rapportgenerering {date}. Denna del använder dagens öppna poster och årsöversikt, inte historisk status vid kvartalsslut.',
  'adv.rpt.period.rolling': 'Rullande 12 månader fram till {to}, jämfört med de föregående 12 månaderna.',
  'adv.rpt.period.nativeSales': 'Kund- och fakturadetaljer avser bokförda fakturor daterade i kvartalet. Importerade årssammanställningar utan kvartalsfördelning ingår inte här.',
  'adv.rpt.period.budget': 'Bokfört i valt kvartal jämförs med budgeten för samma tre månader.',
  'adv.rpt.period.pdfUnavailable': 'Den nya PDF-utformningen är inte tillgänglig på servern ännu. Försök igen efter uppdateringen.',
  'adv.rpt.slides.present': 'Presentera',
  'adv.rpt.slides.exit': 'Avsluta presentation',
  'adv.rpt.slides.readable': 'Läs sidans text',
  'adv.rpt.slides.previous': 'Tillbaka',
  'adv.rpt.slides.next': 'Nästa',
  'adv.rpt.slides.page': 'Sida {current} av {total}',
  'adv.rpt.modal.title': 'Skapa rapport',
  'adv.rpt.modal.intro': 'Välj en rapportmall. SuperPlumma hämtar siffrorna från din bokföring och sätter ihop ett utkast som du kan gå igenom innan det delas.',
  'adv.rpt.modal.generate': 'Generera rapport',
  'adv.rpt.modal.cancel': 'Avbryt',
  'adv.rpt.modal.basis': 'Dataunderlag: {sources}',
  'adv.rpt.modal.year': 'Räkenskapsår',
  'adv.rpt.modal.saved': 'Sparade rapporter',
  'adv.rpt.modal.savedEmpty': 'Du har inga sparade rapporter ännu.',
  'adv.rpt.modal.open': 'Öppna',
  'adv.rpt.modal.delete': 'Ta bort',
  'adv.rpt.modal.deleted': 'Rapporten har tagits bort.',
  'adv.rpt.hero.cta': 'Skapa rapport',
  'adv.rpt.saved.title': 'Sparade rapporter',
  'adv.rpt.saved.tab': 'Sparade rapporter',
  'adv.rpt.saved.description': 'Rapporter som du sparar ligger kvar som ögonblicksbilder och ändras inte när bokföringen uppdateras.',
  'adv.rpt.saved.count': '{count} av {limit} rapporter sparade',
  'adv.rpt.saved.limitError': 'Du kan spara högst {limit} rapporter. Ta bort en rapport innan du sparar en ny.',
  'adv.rpt.saved.loading': 'Hämtar sparade rapporter …',
  'adv.rpt.saved.emptyTitle': 'Inga sparade rapporter',
  'adv.rpt.saved.emptyText': 'Skapa en rapport och spara den när du vill behålla just den här versionen.',
  'adv.rpt.saved.loadFailed': 'Det gick inte att hämta sparade rapporter.',
  'adv.rpt.saved.deleteFailed': 'Det gick inte att ta bort rapporten.',
  'adv.rpt.tpl.styre.name': 'Styrelse- och ledningsrapport',
  'adv.rpt.tpl.styre.desc': 'Heltäckande rapport till styrelsen med resultat, likviditet, risker och rekommenderade åtgärder.',
  'adv.rpt.tpl.manedsrapport.name': 'Månadsrapport',
  'adv.rpt.tpl.manedsrapport.desc': 'Status för vald månad med budget, jämförelse med föregående år, trend och rekommenderade nästa steg.',
  'adv.rpt.tpl.likviditet.name': 'Likviditetsrapport',
  'adv.rpt.tpl.likviditet.desc': 'Öppna poster, buffert och löpande saldo baserat på bokförda siffror.',
  'adv.rpt.tpl.avvik.name': 'Resultat- och avvikelserapport',
  'adv.rpt.tpl.avvik.desc': 'De största avvikelserna mot budget hittills i år och de kostnadsrader som har förändrats mest.',
  'adv.rpt.tpl.kunde.name': 'Kund- och försäljningsrapport',
  'adv.rpt.tpl.kunde.desc': 'Försäljningsutveckling, största kunder, kundkoncentration och utestående.',
  'adv.rpt.tpl.kostnad.name': 'Kostnadsrapport',
  'adv.rpt.tpl.kostnad.desc': 'Kostnadsutveckling, de största leverantörerna och verifikationer som saknar underlag.',
  'adv.rpt.tpl.utestaende.name': 'Utestående poster',
  'adv.rpt.tpl.utestaende.desc': 'Obetalda kund- och leverantörsposter fördelade på förfallna och ej förfallna.',
  'adv.rpt.tpl.arsoppsummering.name': 'Årssammanställning',
  'adv.rpt.tpl.arsoppsummering.desc': 'Sammanfattar hela året — resultat, balansräkning, försäljning, kostnader och risker.',
  'adv.rpt.length.2to3': '2–3 sidor',
  'adv.rpt.length.2to4': '2–4 sidor',
  'adv.rpt.length.3to5': '3–5 sidor',
  'adv.rpt.length.4to6': '4–6 sidor',
  'adv.rpt.length.8to12': '8–12 sidor',
  'adv.rpt.length.variable': 'Omfånget följer dataunderlaget',
  'adv.rpt.length.10to14': '10–14 sidor',
  'adv.rpt.doc.contents': 'Innehåll',
  'adv.rpt.doc.brand': 'PLUMME / AI-RÅDGIVARE',
  'adv.rpt.doc.continued': 'forts.',
  'adv.rpt.doc.back': 'Tillbaka',
  'adv.rpt.doc.draft': 'Utkast',
  'adv.rpt.doc.saved': 'Sparad',
  'adv.rpt.doc.save': 'Spara',
  'adv.rpt.doc.savedToast': 'Rapporten har sparats.',
  'adv.rpt.doc.exportPdf': 'Exportera PDF',
  'adv.rpt.doc.exportPptx': 'Ladda ner PowerPoint',
  'adv.rpt.doc.exportingPptx': 'Skapar PowerPoint …',
  'adv.rpt.doc.exportPptxFailed': 'Det gick inte att skapa PowerPoint-filen. Försök igen.',
  'adv.rpt.doc.presentation': 'PRESENTATION',
  'adv.rpt.doc.coverFoot': 'Genererad från rapportunderlaget i Plumme',
  'adv.rpt.doc.exporting': 'Skapar PDF …',
  'adv.rpt.doc.exportFailed': 'Det gick inte att skapa rapportfilen. Försök igen.',
  'adv.rpt.doc.period': '{year} · {months} månader av året',
  'adv.rpt.doc.createTask': 'Skapa uppgift',
  'adv.rpt.doc.taskCreated': 'Lagd i åtgärdscentret med uppföljning {date}.',
  'adv.rpt.doc.taskFailed': 'Det gick inte att skapa uppgiften.',
  'adv.rpt.doc.taskNote': 'Skapad från {report}.',
  'adv.rpt.narr.section': 'Sammanfattning från SuperPlumma',
  'adv.rpt.narr.tag': 'Skriven av SuperPlumma',
  'adv.rpt.narr.idle': 'Låt SuperPlumma läsa rapporten och skriva sammanfattningen: vad som står på spel, vad som faktiskt rörde sig och vad du bör göra nu.',
  'adv.rpt.narr.write': 'Skriv sammanfattning',
  'adv.rpt.narr.rewrite': 'Skriv om',
  'adv.rpt.narr.loading': 'SuperPlumma läser rapporten …',
  'adv.rpt.narr.failed': 'Det gick inte att skriva sammanfattningen. Siffrorna i rapporten är ändå kompletta.',
  'adv.rpt.narr.drivers': 'Detta rörde sig',
  'adv.rpt.narr.watch': 'Detta bör följas upp',
  'adv.rpt.narr.nextStep': 'Nästa steg: ',
  'adv.rpt.narr.foot': 'Sammanfattningen är skriven utifrån siffrorna i rapporten. Alla belopp kontrolleras mot rapporten innan texten visas.',
  'adv.rpt.sec.changeSince': 'Ändringar sedan föregående rapport',
  'adv.rpt.col.lastReport': 'Föregående rapport',
  'adv.rpt.col.now': 'Nu',
  'adv.rpt.col.change': 'Förändring',
  'adv.rpt.note.changeSinceBasis': 'Jämfört med rapporten som sparades {date}. Siffrorna där är en ögonblicksbild och ändras inte i efterhand.',
  'adv.rpt.empty.noPreviousReport': 'Detta är den första sparade rapporten av denna typ för året. Nästa gång visar det här avsnittet vad som har ändrats sedan nu.',
  'adv.rpt.empty.noComparableReport': 'Föregående rapport har inga nyckeltal att jämföra mot.',
  'adv.rpt.sec.summary': 'Sammanfattning',
  'adv.rpt.sec.events': 'Väsentliga händelser',
  'adv.rpt.sec.keyFigures': 'Ekonomiska nyckeltal',
  'adv.rpt.sec.budget': 'Resultat mot budget',
  'adv.rpt.sec.liquidity': 'Likviditet och betalningsåtaganden',
  'adv.rpt.sec.forecast': 'Löpande saldo under året',
  'adv.rpt.sec.balance': 'Balansräkning och soliditet',
  'adv.rpt.sec.resultTrend': 'Resultatutveckling',
  'adv.rpt.sec.sales': 'Försäljning och kundutveckling',
  'adv.rpt.sec.customerChange': 'Kundlojalitet och betalningstid',
  'adv.rpt.sec.costTrend': 'Kostnadsutveckling',
  'adv.rpt.sec.suppliers': 'Största leverantörer',
  'adv.rpt.sec.voucherReview': 'Verifikationer att granska',
  'adv.rpt.sec.receivables': 'Kundposter',
  'adv.rpt.sec.payables': 'Leverantörsposter',
  'adv.rpt.sec.risk': 'Risk och osäkerhet',
  'adv.rpt.sec.actions': 'Rekommenderade åtgärder',
  'adv.rpt.sec.decisions': 'Ärenden för beslut',
  'adv.rpt.sec.dataBasis': 'Dataunderlag',
  'adv.rpt.sec.bridge': 'Vad som påverkade resultatet',
  'adv.rpt.sec.workingCapital': 'Rörelsekapital och bindningstid',
  'adv.rpt.sec.rolling': 'Rullande 12 månader',
  'adv.rpt.col.driver': 'Drivkraft',
  'adv.rpt.col.effect': 'Effekt',
  'adv.rpt.col.priority': 'Prioritet',
  'adv.rpt.bridge.opening': 'Resultat {year}',
  'adv.rpt.bridge.closing': 'Resultat {year}',
  'adv.rpt.bridge.revenue': 'Förändring i intäkter',
  'adv.rpt.bridge.finance': 'Förändring i finansiella poster',
  'adv.rpt.bridge.other': 'Övriga poster ({count} rader)',
  'adv.rpt.bridge.readGuide': 'Läs från vänster: Börja med förra årets resultat. Grönt höjer resultatet, rött drar ner det. Sista stapeln är årets resultat. Beloppen nedan visar varje bidrag.',
  'adv.rpt.bridge.readShort': 'Från förra året till i år · Grönt höjer resultatet · Rött drar ner',
  'adv.rpt.note.bridgeBasis': 'Rader med en effekt under {amount} har slagits ihop. Bryggan går från resultatet {year} till årets resultat, och summan av drivarna är hela förändringen.',
  'adv.rpt.empty.noBridgeBasis': 'Utan bokförda siffror för {year} kan förändringen inte brytas ner på drivare.',
  'adv.rpt.empty.noBridgeChange': 'Resultatet är oförändrat sedan {year}.',
  'adv.rpt.metric.receivableDays': 'Kundfordringar',
  'adv.rpt.metric.payableDays': 'Leverantörsskulder',
  'adv.rpt.metric.capitalGap': 'Bindningstid netto',
  'adv.rpt.metric.measuredPaymentDays': 'Faktisk betalningstid',
  'adv.rpt.metric.netCapitalTied': 'Netto bundet kapital',
  'adv.rpt.note.capitalGapPositive': 'Du väntar {days} dagar längre på pengarna än du själv tar på dig att betala. Det är den perioden som verksamheten måste finansieras med egen kassa.',
  'adv.rpt.note.capitalGapNegative': 'Du betalar senare än du får betalt. Leverantörskrediten finansierar då en del av verksamheten.',
  'adv.rpt.note.capitalGapUnknown': 'Netto bindningstid kan inte beräknas eftersom intäkts- eller kostnadsunderlaget saknas.',
  'adv.rpt.note.workingCapitalBasis': 'Fordrings- och leverantörsdagarna är uppskattningar baserade på öppna poster och {months} månader av rapportåret. Faktisk betalningstid mäts bara på betalda kundfakturor och är därför inte samma beräkning.',
  'adv.rpt.empty.noWorkingCapital': 'Inga öppna kund- eller leverantörsposter att mäta bindningstid på.',
  'adv.rpt.cell.vsPrevious12': 'mot föregående 12',
  'adv.rpt.note.rollingBasis': 'Fönstret är de senaste {months} bokförda månaderna, så jämförelsen går över årsskiftet och påverkas inte av säsong.',
  'adv.rpt.note.noRollingComparison': 'Det finns inte tillräckligt med historik för att jämföra med de föregående 12 månaderna.',
  'adv.rpt.empty.noRollingBasis': 'För lite bokförd historik för att bygga ett rullande 12-månadersfönster.',
  'adv.rpt.certainty.planned': 'Planerad',
  'adv.rpt.summary.profit': 'Efter {months} månader av {year} har {income} i intäkter bokförts och ett överskott på {result}.',
  'adv.rpt.summary.loss': 'Efter {months} månader av {year} har {income} i intäkter bokförts och ett underskott på {result}.',
  'adv.rpt.summary.margin': 'Det ger en resultatmarginal på {margin} %.',
  'adv.rpt.kpi.income': 'Intäkter',
  'adv.rpt.kpi.costs': 'Kostnader',
  'adv.rpt.kpi.result': 'Resultat',
  'adv.rpt.kpi.margin': 'Resultatmarginal',
  'adv.rpt.kpi.revenue': 'Fakturerad försäljning',
  'adv.rpt.kpi.invoiceCount': 'Antal fakturor',
  'adv.rpt.kpi.avgInvoice': 'Snitt per faktura',
  'adv.rpt.kpi.customerCount': 'Antal kunder',
  'adv.rpt.metric.receivables': 'Utestående från kunder',
  'adv.rpt.metric.payables': 'Skuld till leverantörer',
  'adv.rpt.metric.buffer': 'Likviditetsbuffert',
  'adv.rpt.metric.lowestBalance': 'Lägsta saldo under året',
  'adv.rpt.metric.assets': 'Summa tillgångar',
  'adv.rpt.metric.equityAndDebt': 'Summa eget kapital och skulder',
  'adv.rpt.metric.solidity': 'Soliditet',
  'adv.rpt.metric.repeatRate': 'Andel återkommande kunder',
  'adv.rpt.metric.avgPaymentDays': 'Snitt betalningstid',
  'adv.rpt.unit.days': '{days} dagar',
  'adv.rpt.col.line': 'Rad',
  'adv.rpt.col.account': 'Konto',
  'adv.rpt.col.budgetToDate': 'Budget hittills',
  'adv.rpt.col.actual': 'Bokfört',
  'adv.rpt.col.variance': 'Avvikelse',
  'adv.rpt.col.month': 'Månad',
  'adv.rpt.col.in': 'In',
  'adv.rpt.col.out': 'Ut',
  'adv.rpt.col.balance': 'Saldo',
  'adv.rpt.col.certainty': 'Underlag',
  'adv.rpt.col.income': 'Intäkter',
  'adv.rpt.col.costs': 'Kostnader',
  'adv.rpt.col.result': 'Resultat',
  'adv.rpt.col.share': 'Andel',
  'adv.rpt.chart.budgetActual': 'Budget mot bokfört hittills',
  'adv.rpt.chart.monthlyResult': 'Resultat per månad',
  'adv.rpt.chart.incomeCosts': 'Intäkter och kostnader per månad',
  'adv.rpt.chart.summaryResult': 'Från intäkter till resultat',
  'adv.rpt.chart.keyFiguresComparison': 'Nyckeltal mot förra året',
  'adv.rpt.chart.previousPeriod': 'Föregående period',
  'adv.rpt.chart.currentPeriod': 'Denna period',
  'adv.rpt.chart.cumulativeResult': 'Ackumulerat resultat under året',
  'adv.rpt.chart.runningBalance': 'Löpande saldo och likviditetsbuffert',
  'adv.rpt.chart.openItemsDue': 'Öppna poster efter förfallostatus',
  'adv.rpt.chart.workingCapitalGap': 'Kapital bundet i öppna poster',
  'adv.rpt.chart.balanceBasis': 'Bokförda balansgrupper',
  'adv.rpt.chart.bookedBalance': 'Bokfört saldo',
  'adv.rpt.chart.capitalStructure': 'Kapitalstruktur',
  'adv.rpt.chart.equityShare': 'Eget kapital',
  'adv.rpt.chart.otherFinancing': 'Annan finansiering',
  'adv.rpt.chart.profit': 'Överskott',
  'adv.rpt.chart.loss': 'Underskott',
  'adv.rpt.col.amount': 'Belopp',
  'adv.rpt.col.changeYoy': 'Förändring mot i fjol',
  'adv.rpt.col.status': 'Status',
  'adv.rpt.row.income': 'Intäkter',
  'adv.rpt.row.costs': 'Kostnader',
  'adv.rpt.row.notDue': 'Ej förfallet',
  'adv.rpt.row.current': 'Ej förfallet',
  'adv.rpt.row.overdue': 'Förfallet',
  'adv.rpt.row.total': 'Summa',
  'adv.rpt.cell.vsPreviousYear': 'mot i fjol',
  'adv.rpt.cell.noBasis': 'Ingen jämförelse',
  'adv.rpt.month.jan': 'Januari',
  'adv.rpt.month.feb': 'Februari',
  'adv.rpt.month.mar': 'Mars',
  'adv.rpt.month.apr': 'April',
  'adv.rpt.month.may': 'Maj',
  'adv.rpt.month.jun': 'Juni',
  'adv.rpt.month.jul': 'Juli',
  'adv.rpt.month.aug': 'Augusti',
  'adv.rpt.month.sep': 'September',
  'adv.rpt.month.oct': 'Oktober',
  'adv.rpt.month.nov': 'November',
  'adv.rpt.month.dec': 'December',
  'adv.rpt.certainty.confirmed': 'Bokfört',
  'adv.rpt.certainty.expected': 'Innevarande månad',
  'adv.rpt.certainty.uncertain': 'Inte bokfört än',
  'adv.rpt.budget.intro': 'Bokförda siffror för {months} månader av {year} jämförs med budgeten för samma månader, inte med helårsbudgeten.',
  'adv.rpt.vouchers.missing': '{count} bokförda inköp saknar verifikation. Totalt gäller det {net} i underlag och {vat} i avdragen moms.',
  'adv.rpt.action.impact': '{label}: {value}',
  'adv.rpt.priority.high': 'Hög',
  'adv.rpt.priority.medium': 'Medel',
  'adv.rpt.priority.low': 'Låg',
  'adv.rpt.severity.critical': 'Kritisk',
  'adv.rpt.severity.watch': 'Bör följas upp',
  'adv.rpt.severity.info': 'För information',
  'adv.rpt.decision.risk': 'Ta ställning till: {name}',
  'adv.rpt.decision.opportunity': 'Överväg: {name}',
  'adv.rpt.decision.freeCapital': 'Bestäm hur ledigt kapital på {amount} ska användas.',
  'adv.rpt.note.noPreviousYear': 'Det finns inga bokförda siffror för {year}, så förändringen mot förra året kan inte beräknas.',
  'adv.rpt.note.partialYear': 'Perioden är inte avslutad. Siffrorna täcker {months} månader av {year}.',
  'adv.rpt.note.noMaterialVariance': 'Inga enskilda rader avviker väsentligt från budgeten.',
  'adv.rpt.note.unbudgeted': '{count} konton har bokförda belopp utan budgetrad. De ingår i totalen.',
  'adv.rpt.note.belowBuffer': 'Lägsta beräknade saldo är {lowest}, under valt buffertmål på {buffer}.',
  'adv.rpt.note.aboveBuffer': 'Det löpande saldot ligger över bufferten på {buffer} under hela perioden.',
  'adv.rpt.note.forecastIsBooked': 'Kurvan är ett löpande saldo av bokförda siffror, inte en prognosmodell. Månader där inget har bokförts än ligger platt.',
  'adv.rpt.note.balanceGrouping': 'Eget kapital och skulder visas tillsammans, så som råbalansen grupperar dem.',
  'adv.rpt.note.balanceInterimBasis': 'Balansgrupperna visas som de är bokförda på rapportdatumet. Skillnaden mellan sidorna kan omfatta periodens resultat och ska inte läsas som en färdigställd årsbalans.',
  'adv.rpt.note.noCustomerSplit': 'Försäljningen är inte fördelad per kund i underlaget.',
  'adv.rpt.note.concentration': '{name} står för {pct} % av den fakturerade försäljningen.',
  'adv.rpt.note.customerBasis': 'Betalningstiden är mätt på fakturor som faktiskt har betalats.',
  'adv.rpt.note.costJump': 'En eller flera kostnadsrader har ökat mer än 25 % mot förra året.',
  'adv.rpt.note.topFiveOnly': 'Visar de fem största. Resten ingår i totalerna men listas inte.',
  'adv.rpt.note.vouchersComplete': 'Alla bokförda inköp har verifikation.',
  'adv.rpt.note.vouchersRequired': 'Bokføringsloven kräver dokumentation för varje kontering. Saknade verifikationer bör tas fram innan perioden rapporteras.',
  'adv.rpt.note.overdueSales': '{amount} är förfallet från kunder och bör följas upp.',
  'adv.rpt.note.overduePurchases': '{amount} är förfallet till leverantörer.',
  'adv.rpt.note.noRisks': 'Inga riskförhållanden har hittats i de bokförda siffrorna.',
  'adv.rpt.note.noActions': 'Inga åtgärder rekommenderas just nu.',
  'adv.rpt.note.notAProtocol': 'Det här är beslutsstöd och ersätter inte styrelseprotokoll. Beslut fattas av styrelsen.',
  'adv.rpt.empty.noBookkeeping': 'Inga intäkter eller kostnader har bokförts för {year}. Rapporten får siffror så snart det finns verifikationer.',
  'adv.rpt.empty.noEvents': 'Inga väsentliga förändringar har registrerats under perioden.',
  'adv.rpt.empty.noBudget': 'Det finns ingen budget för {year}. Lägg in en budget för att få avvikelser i rapporten.',
  'adv.rpt.empty.noLiquidityBasis': 'Inga öppna kund- eller leverantörsposter och inga bokförda rörelser att bygga saldot på.',
  'adv.rpt.empty.noForecast': 'Det finns inget avstämt kassaunderlag för saldokurvan.',
  'adv.rpt.empty.noBalance': 'Råbalansen för {year} är tom.',
  'adv.rpt.empty.noSales': 'Det finns ingen bokförd fakturerad försäljning för {year}.',
  'adv.rpt.empty.noCustomerHistory': 'För lite kundhistorik för att mäta återköp och betalningstid.',
  'adv.rpt.empty.noCosts': 'Det finns inga bokförda kostnader för {year}.',
  'adv.rpt.empty.noSupplierSplit': 'Kostnaderna är inte fördelade per leverantör i underlaget.',
  'adv.rpt.empty.noReceivables': 'Inga utestående kundposter.',
  'adv.rpt.empty.noPayables': 'Inga utestående leverantörsposter.',
  'adv.rpt.empty.noDecisions': 'Inga ärenden kräver beslut just nu.',
  'adv.rpt.source.result': 'Resultaträkning',
  'adv.rpt.source.balance': 'Råbalans',
  'adv.rpt.source.openItems': 'Öppna kund- och leverantörsposter',
  'adv.rpt.source.budget': 'Budget',
  'adv.rpt.source.bank': 'Banktransaktioner',
  'adv.rpt.source.invoices': 'Kundfakturor',
  'adv.rpt.source.purchases': 'Leverantörsfakturor',
  'adv.rpt.source.vouchers': 'Verifikationer',
  'adv.rpt.basis.generated': 'Genererad {date}.',
  'adv.rpt.basis.period': 'Perioden omfattar {months} månader av {year}.',
  'adv.rpt.basis.noPreviousYear': 'Inga bokförda siffror för {year} — jämförelse med föregående år saknas.',
  'adv.rpt.basis.noBudget': 'Inga budgetrader för {year}.',
  'adv.rpt.basis.noPartySplit': 'Fördelningen per kund och leverantör är ofullständig. Kundöversikten visar det som kan spåras till fakturerad försäljning.',
  'adv.rpt.basis.topFive': 'Kund- och leverantörslistor visar de fem största.',
  'adv.rpt.basis.bookedOnly': 'Redovisningssiffror kommer från bokföringen. Buffert är ett mål, inte ett bokfört saldo. Planerade betalningar och beräknade nyckeltal är markerade i rapporten.',
  'adv.rpt.period.monthShort': '{month}/{year}',
  'adv.rpt.period.vsPreviousMonth': 'jämfört med föregående månad',
  'adv.rpt.monthPicker.title': 'Välj månad för månadsrapporten',
  'adv.rpt.monthPicker.intro': 'Välj en av de senaste 24 kalendermånaderna. Rapporten använder bara bokförda siffror, budget och jämförelser för den valda månaden.',
  'adv.rpt.monthPicker.separate': 'Månadsrapporten har ett eget månadsval och påverkas inte av års- eller kvartalsvalet för andra rapporter.',
  'adv.rpt.monthPicker.continue': 'Välj månad',
  'adv.rpt.monthPicker.back': 'Tillbaka till rapportmallar',
  'adv.rpt.monthPicker.generate': 'Generera månadsrapport',
  'adv.rpt.sec.monthlyStatus': 'Status för månaden',
  'adv.rpt.sec.monthlyBudget': 'Månaden mot budget',
  'adv.rpt.sec.monthlyComparison': 'Samma månad i fjol',
  'adv.rpt.sec.monthlyTrend': 'Utveckling senaste 12 månaderna',
  'adv.rpt.sec.monthlyInsights': 'Månadens bedömning och nästa steg',
  'adv.rpt.empty.noMonthlyBudget': 'Det finns ingen budget för den valda månaden.',
  'adv.rpt.empty.noMonthlyComparison': 'Det finns inga bokförda siffror för samma månad i fjol.',
  'adv.rpt.empty.noMonthlyTrend': 'Det finns inga bokförda månadssiffror i tolvmånadersfönstret.',
  'adv.rpt.col.budget': 'Budget',
  'adv.rpt.col.variancePct': 'Avvikelse i %',
  'adv.rpt.row.result': 'Resultat',
  'adv.rpt.chart.monthBudgetActual': 'Budget och utfall för månaden',
  'adv.rpt.chart.sameMonthComparison': 'Vald månad mot samma månad i fjol',
  'adv.rpt.metric.averageMonthlyResult': 'Genomsnittligt resultat per månad',
  'adv.rpt.metric.bestMonthlyResult': 'Bästa månad',
  'adv.rpt.metric.weakestMonthlyResult': 'Svagaste månad',
  'adv.rpt.monthly.statusProfit': 'Månaden slutade med ett överskott på {result} och en rörelsemarginal på {margin} %.',
  'adv.rpt.monthly.statusLoss': 'Månaden slutade med ett underskott på {result} och en rörelsemarginal på {margin} %.',
  'adv.rpt.monthly.budgetAbove': 'Resultatet är {amount} bättre än budgeten för månaden.',
  'adv.rpt.monthly.budgetBelow': 'Resultatet är {amount} svagare än budgeten för månaden.',
  'adv.rpt.monthly.marginChange': 'Rörelsemarginalen har ändrats med {change} procentenheter jämfört med samma månad i fjol.',
  'adv.rpt.monthly.trendBasis': 'Utvecklingen visar upp till 12 bokförda kalendermånader fram till och med den valda månaden.',
  'adv.rpt.monthly.insightLossTitle': 'Negativt månadsresultat',
  'adv.rpt.monthly.insightLossBody': 'Kostnaderna var {amount} högre än intäkterna under den valda månaden.',
  'adv.rpt.monthly.insightProfitTitle': 'Positivt månadsresultat',
  'adv.rpt.monthly.insightProfitBody': 'Månaden gav ett överskott på {amount}. Följ upp vilka intäkter och kostnader som bör upprepas.',
  'adv.rpt.monthly.insightIncomeDownTitle': 'Lägre intäkter än i fjol',
  'adv.rpt.monthly.insightIncomeDownBody': 'Intäkterna är {change} % lägre än samma månad i fjol.',
  'adv.rpt.monthly.insightCostsTitle': 'Kostnader över budget',
  'adv.rpt.monthly.insightCostsBody': 'Kostnaderna är {amount} högre än budgeten för månaden.',
  'adv.rpt.monthly.insightBudgetTitle': 'Resultat under budget',
  'adv.rpt.monthly.insightBudgetBody': 'Resultatet är {amount} svagare än budgeten för månaden.',
  'adv.rpt.monthly.stepReviewDrivers': 'Gå igenom posterna som förklarar månadsresultatet och klargör vad som är bestående.',
  'adv.rpt.monthly.stepRevenue': 'Följ upp intäktsminskningen jämfört med samma månad i fjol.',
  'adv.rpt.monthly.stepCosts': 'Identifiera kostnaderna som ligger över månadsbudgeten.',
  'adv.rpt.monthly.stepBudget': 'Uppdatera åtgärderna för att stänga resultatavvikelsen mot månadsbudgeten.',
  'adv.rpt.monthly.stepContinue': 'Behåll drivkrafterna bakom det positiva månadsresultatet och följ utvecklingen nästa månad.',
});
